'use client';

import React from 'react';

/**
 * Custom hook that determines if the code is running on the client side.
 *
 * @returns {Object} An object containing a boolean `isClient` which is `true` if the code is running on the client side, otherwise `false`.
 *
 * @example
 * const { isClient } = useIsClient();
 * if (isClient) {
 *   // Code that should only run on the client side
 * }
 */
export function useIsClientCds() {
  const [isClient, setIsClient] = React.useState(false);

  React.useEffect(() => {
    setIsClient(true);
  }, []);

  return { isClient };
}
